import { useState } from "react";

import { useGetProfile } from "@synthesis/shared-services/external/profile/hooks";

import { useUserInfo } from "../../shared/hooks/use-user-info";

import { GoBackButton } from "./local-components/go-back-button";
import { UserInfoEditView } from "./local-components/user-info-edit-view";
import { UserInfoSection } from "./local-components/user-info-section";
import {
  displayProfileValue,
  formatRegistrationDate,
  PASSWORD_MASK,
  PLACEHOLDER_CORPORATE_EMAIL,
  PLACEHOLDER_ORGANIZATION,
  PLACEHOLDER_PHONE,
  PLACEHOLDER_POSITION,
} from "./user-info-page.lib";

const UserInfoPage = () => {
  const userInfo = useUserInfo();
  const { data: profile, isLoading: isProfileLoading, isSuccess: isProfileReady } = useGetProfile();
  const [isEditing, setIsEditing] = useState(false);

  const fullName = [profile?.lastName, profile?.firstName, profile?.middleName].filter(Boolean).join(" ") || userInfo?.fullName || "—";
  const email = profile?.email || userInfo?.email || "—";
  const initials = userInfo?.initials ?? "—";

  const organization = profile?.organization?.trim() ?? "";
  const position = profile?.position?.trim() ?? "";
  const contactPhone = profile?.contactPhone?.trim() ?? "";
  const corporateEmail = profile?.corporateEmail?.trim() ?? "";
  const lastName = profile?.lastName?.trim() || userInfo?.family_name || "";
  const firstName = profile?.firstName?.trim() || userInfo?.given_name || "";
  const middleName = profile?.middleName?.trim() || userInfo?.middle_name || "";

  return (
    <main className="flex min-h-0 w-full flex-1 flex-col overflow-y-auto px-8 py-6">
      <div className="mx-auto flex w-full max-w-[1210px] flex-col gap-6 px-9">
        <GoBackButton className="w-fit" />

        <div className="">
          <div className="">
            <div className="bg-neutrals-30 relative flex items-center gap-[38px] rounded-l-[2.875rem] rounded-r-xl p-1.5">
              <div className="flex size-[80px] shrink-0 items-center justify-center rounded-full bg-[#655C5C]">
                <span className="subtitle-sm text-neutrals-white text-[24px]">{initials}</span>
              </div>
              <h1 className="heading-h4 text-neutrals-white truncate text-[32px]">{fullName}</h1>
            </div>
          </div>

          {isEditing && isProfileReady ? (
            <UserInfoEditView
              organization={organization}
              position={position}
              contactPhone={contactPhone}
              corporateEmail={corporateEmail}
              lastName={lastName}
              firstName={firstName}
              middleName={middleName}
              loginEmail={email}
              onCancel={() => setIsEditing(false)}
              onSaved={() => setIsEditing(false)}
            />
          ) : (
            <div className="flex flex-col gap-8 px-4 py-6 md:py-8">
              <UserInfoSection
                title="Информация об учётной записи"
                description="Ваши данные, указанные при регистрации."
                withEditButton
                onEditClick={() => {
                  if (isProfileReady) {
                    setIsEditing(true);
                  }
                }}
                fields={[
                  { label: "ФИО", value: fullName },
                  { label: "Логин / E-mail", value: email },
                  {
                    label: "Дата регистрации",
                    value: formatRegistrationDate(profile?.registrationDate),
                    isLoading: isProfileLoading,
                  },
                  { label: "Пароль", value: PASSWORD_MASK },
                ]}
              />

              <UserInfoSection
                title="Рабочие данные"
                description="Используются для коммуникации по заявкам. Видны участникам процесса в системе."
                fields={[
                  {
                    label: "Организация",
                    value: displayProfileValue(profile?.organization, PLACEHOLDER_ORGANIZATION),
                    isLoading: isProfileLoading,
                  },
                  {
                    label: "Должность",
                    value: displayProfileValue(profile?.position, PLACEHOLDER_POSITION),
                    isLoading: isProfileLoading,
                  },
                  {
                    label: "Контактный телефон (рабочий)",
                    value: displayProfileValue(profile?.contactPhone, PLACEHOLDER_PHONE),
                    isLoading: isProfileLoading,
                  },
                  {
                    label: "Корпоративная почта",
                    value: displayProfileValue(profile?.corporateEmail, PLACEHOLDER_CORPORATE_EMAIL),
                    isLoading: isProfileLoading,
                  },
                ]}
              />
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default UserInfoPage;
